import React, { useEffect, useState } from 'react'
import AppButton from 'components/atoms/AppButton/AppButton'
import AppInput from 'components/atoms/AppInput/AppInput'
import { CriteriaList, Filter } from 'interfaces/rule'
import CheckIcon from '../../../assets/check.png'

interface Props {
    criterias: CriteriaList[]
    onChange: (data: Filter) => void
}

export default function RulesFilter({ criterias, onChange }: Props) {
    const [filter, setFilter] = useState<Filter>({
        name: '',
        criteria_types: [],
        page: 1,
    })

    const handleSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            const target = e.target as HTMLInputElement
            setFilter((prevFilter) => ({
                ...prevFilter,
                name: target.value,
                page: 1,
            }))
        }
    }

    const handleCriteria = (value: number) => {
        setFilter((prevFilter) => {
            const currentCriterias = prevFilter.criteria_types
            const exists = currentCriterias.includes(value)
            return {
                ...prevFilter,
                criteria_types: exists
                    ? currentCriterias.filter((id) => id !== value)
                    : [...currentCriterias, value],
                page: 1,
            }
        })
    }

    useEffect(() => {
        onChange(filter)
    }, [filter])

    return (
        <div className="flex flex-wrap gap-3 px-0 w-full items-center">
            <div className="flex-shrink-0 min-w-[200px]">
                <AppInput
                    placeholder="Buscar"
                    name="rule"
                    onKeyDown={handleSearch}
                    showSearchIcon
                />
            </div>
            {criterias.map((criteria) => (
                <AppButton
                    key={criteria.id}
                    title={criteria.name}
                    size="sm"
                    state="default"
                    rounded
                    icon={
                        filter.criteria_types.includes(criteria.id) ? (
                            <img
                                src={CheckIcon}
                                alt="check"
                                className="w-4 h-4"
                            />
                        ) : null
                    }
                    className={`text-sm font-normal ${
                        filter.criteria_types.includes(criteria.id)
                            ? 'active'
                            : ''
                    }`}
                    onClick={() => handleCriteria(criteria.id)}
                />
            ))}
        </div>
    )
}
